import {
  ApiBlueprint,
  PageBlueprint,
  createApiFactory,
  createFrontendPlugin,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/frontend-plugin-api';
import { backendAuthApiRef } from '@internal/plugin-neo4j-auth-common';
import {
  cloudCostsApiRef,
  CloudCostsRestApi,
} from '@internal/backstage-plugin-neo4j-cloud-costs-react';
import { rootRouteRef } from './routes';

// ── API (→ global API registry) ─────────────────────────
const cloudCostsApi = ApiBlueprint.make({
  name: 'cloud-costs-api',
  params: defineParams =>
    defineParams(
      createApiFactory({
        api: cloudCostsApiRef,
        deps: {
          discoveryApi: discoveryApiRef,
          fetchApi: fetchApiRef,
          backendAuthApi: backendAuthApiRef,
        },
        factory: ({ discoveryApi, fetchApi, backendAuthApi }) =>
          new CloudCostsRestApi({
            discoveryApi,
            fetchApi,
            auth: backendAuthApi,
          }),
      }),
    ),
});

// ── Route (→ app/routes) ────────────────────────────────
const cloudCostsPage = PageBlueprint.make({
  params: {
    path: '/cloud-costs',
    routeRef: rootRouteRef,
    noHeader: true,
    loader: () => import('./pages/ExamplePage').then(m => <m.ExamplePage />),
  },
});

export default createFrontendPlugin({
  info: {
    packageJson: () => import('../package.json'),
    manifest: () => import('../catalog-info.yaml'),
  },
  pluginId: 'neo4j-cloud-costs',
  extensions: [cloudCostsApi, cloudCostsPage],
  routes: {
    root: rootRouteRef,
  },
});
